import React from 'react';
import { IBreadcrumbItem } from 'src/utils/metatagHelpers';

interface IUseBreadcrumbLogicReturn {
  shouldRender: boolean;
  shouldRenderEllipsis: boolean;
  showBreadcrumbs: boolean;
  setShowBreadcrumb: React.Dispatch<React.SetStateAction<boolean>>;
  visibleItemsStart: IBreadcrumbItem[];
  hiddenItems: IBreadcrumbItem[];
  visibleItemEnd: IBreadcrumbItem | null;
}

export const useBreadcrumb = (items: IBreadcrumbItem[]): IUseBreadcrumbLogicReturn => {
  const [showBreadcrumbs, setShowBreadcrumb] = React.useState(false);
  return React.useMemo(() => {
    const breadcrumbLength = items.length;

    const shouldRender = breadcrumbLength > 1;
    if (!shouldRender) {
      return {
        shouldRender: false,
        showBreadcrumbs,
        shouldRenderEllipsis: false,
        setShowBreadcrumb,
        visibleItemsStart: [],
        hiddenItems: [],
        visibleItemEnd: null,
      };
    }

    const shouldRenderEllipsis = breadcrumbLength >= 4;

    if (shouldRenderEllipsis) {
      return {
        shouldRender: true,
        showBreadcrumbs,
        shouldRenderEllipsis: true,
        setShowBreadcrumb,
        visibleItemsStart: items.slice(0, 2),
        hiddenItems: items.slice(2, -1),
        visibleItemEnd: items[items.length - 1],
      };
    }

    return {
      shouldRender: true,
      showBreadcrumbs,
      shouldRenderEllipsis: false,
      setShowBreadcrumb,
      visibleItemsStart: items,
      hiddenItems: [],
      visibleItemEnd: null,
    };
  }, [items, showBreadcrumbs]);
};
